
import React, { useState } from "react";
import { postFile } from "../services/api";
import useFormHelper from "../helpers/useFormHelper";
import { Button } from "@mui/material";
import fileStyles from "../styles/Home.module.css";
import { comprimirImagen } from "../helpers/image";

// Props del componente de subida de imagen
interface IFileUp2{
    setImgRoute: (link: string) => void; // Devuelve la ruta de la imagen subida
    handleClose: () => void; // Cierra el modal o contenedor
}

const UploadImg: React.FC<IFileUp2> = ({setImgRoute, handleClose}) => {

    const [update, setUpdate] = useState(true); // Controla si ya se seleccionó un archivo
    const [selected, setSelected] = useState([{file: ""}]); // Guarda vista previa de archivos seleccionados

    const states = useState({
        selectedFiles: null, // Guarda los archivos seleccionados
    });

    const {
        values,
        updateValues,
    } = useFormHelper(states);

    async function onFileChange(e: any) {
        updateValues({
            selectedFiles: e.target.files, // Guarda archivos seleccionados en el helper
        });
        const lst : {file:string}[] = [];
        for(let element of e.target.files){
            lst.push({
                file: URL.createObjectURL(element) // Genera URL local para vista previa
            })
        };
        setSelected(lst); // Guarda la lista de vistas previas
        setUpdate(false); // Marca que ya hay archivo para subir
    };

    const onUploadFiles = async () => {
        if (!update) {
            for(let element of values.selectedFiles){
                const formData = new FormData();
                const ename = element.name.replace(".", " ")
                const tag = new Date().getTime().toString();
                const blob = await comprimirImagen(element, 50); // Comprime la imagen antes de subirla
                formData.append(
                    "file",
                    blob,
                    tag + " " + ename + ".jpeg"
                );
    
                formData.append('_method', 'PUT');
 
                await postFile(formData).then(v=>{
                    if(v.data.successed){
                        setImgRoute(`/public/imgs/${v.data.file}`); // Devuelve la ruta generada por el backend
                        handleClose(); // Cierra después de subir correctamente
                    }
                });
            };
        };
    };

    return (
        <div className="rounded-lg shadow text-center py-2 px-3 d-block">
            <div className="rounded form-group inputDnD py-2">
                <input
                    id="file"
                    type="file"
                    name="file"
                    accept="image/*" // Solo permite imágenes
                    className={fileStyles.file}
                    onChange={onFileChange} // Maneja selección de archivo
                    data-title="Arrastra tu Imagen o haz click aqui."
                />
            </div>
            <div className="rounded-lg container-fluid">
                {(selected[0].file) && selected.map((val:any, index)=>
                    <img src={val.file} alt={index.toString()} key={index} width={50} /> // Muestra vista previa
                )}
            </div>
            <Button variant="contained" style={{marginTop:10}} onClick={onUploadFiles}>Subir</Button>
        </div>
    )
}

export default UploadImg;